const initMenu = (lenis) => {
	const $body = document.body;
	lenis.on('scroll', ({ animatedScroll, direction }) => {
		// console.log(animatedScroll);
		animatedScroll > 10 ? $body.classList.add('fixed-menu') : $body.classList.remove('fixed-menu');
		direction > 0 ? $body.classList.add('drop-menu') : $body.classList.remove('drop-menu');
		// ScrollTrigger.update();
	});

	// 菜单按钮 (移动端)
	const toggleMenuBtn = document.querySelector('.js-toggle-menu');
	if (toggleMenuBtn) {
		toggleMenuBtn.addEventListener('click', () => {
			$body.classList.toggle('menu-open');
		});
	}

	// 返回顶部
	const gotop = document.querySelector('.js-gotop');
	if (gotop) {
		gotop.addEventListener('click', () => {
			lenis.scrollTo(0);
		});
	}
};

export { initMenu };
